module.exports = __webpack_public_path__ + "img/confrim2.918a768e.png";